import React, { useState } from 'react';
import communityData from '../../data/community-events.json';

const CATEGORIES = ['All', 'Meetup', 'Workshop', 'CTF Night', 'Online', 'Conference Archive'];

const events = communityData.upcoming;

const modeColors = { offline: '#00e676', online: '#00e5ff' };

export default function UpcomingEvents() {
    const [active, setActive] = useState('All');

    const filtered = active === 'All' ? events : events.filter(e => e.category === active);

    return (
        <section className="ce-upcoming">
            <style>{`
                .ce-upcoming {
                    background: var(--eventflow-black);
                    padding: 80px 0 100px;
                    position: relative; overflow: hidden;
                }
                .ce-upcoming::before {
                    content: '';
                    position: absolute; inset: 0;
                    background: radial-gradient(ellipse at 70% 30%, rgba(var(--eventflow-primary-rgb),0.08) 0%, transparent 55%);
                    pointer-events: none;
                }
                /* section header */
                .ce-sec-tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 12px;
                }
                .ce-sec-tag::before, .ce-sec-tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .ce-sec-title {
                    font-family: var(--eventflow-font);
                    font-size: 44px; font-weight: 900;
                    color: #fff; line-height: 1.1;
                    letter-spacing: -1px; margin-bottom: 12px;
                }
                .ce-sec-title span { color: var(--eventflow-base); }
                /* filters */
                .ce-filters {
                    display: flex; flex-wrap: wrap; gap: 8px;
                    justify-content: center; margin-bottom: 48px;
                }
                .ce-filter {
                    font-family: var(--eventflow-font);
                    font-size: 13px; font-weight: 600;
                    padding: 8px 20px; border-radius: 50px;
                    border: 1px solid rgba(255,255,255,0.1);
                    background: transparent;
                    color: rgba(255,255,255,0.45);
                    cursor: pointer; transition: all 0.25s;
                }
                .ce-filter:hover { border-color: rgba(var(--eventflow-base-rgb),0.4); color: #fff; }
                .ce-filter--active {
                    background: var(--eventflow-base);
                    border-color: var(--eventflow-base);
                    color: #fff;
                }
                /* featured event */
                .ce-featured {
                    background: rgba(var(--eventflow-base-rgb),0.05);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    border-radius: 16px; padding: 32px 36px;
                    margin-bottom: 24px;
                    display: grid;
                    grid-template-columns: 1fr auto;
                    gap: 32px; align-items: center;
                    position: relative; overflow: hidden;
                    transition: all 0.3s;
                }
                .ce-featured::before {
                    content: '';
                    position: absolute; top: 0; left: 0; right: 0; height: 2px;
                    background: linear-gradient(90deg, var(--eventflow-base), var(--eventflow-primary));
                }
                .ce-featured:hover { border-color: rgba(var(--eventflow-base-rgb),0.4); transform: translateY(-2px); }
                .ce-featured__badge {
                    position: absolute; top: 16px; right: 16px;
                    font-family: var(--eventflow-font);
                    font-size: 10px; font-weight: 700;
                    letter-spacing: 2px; text-transform: uppercase;
                    color: #fff; background: var(--eventflow-base);
                    border-radius: 20px; padding: 4px 12px;
                    box-shadow: 0 4px 12px rgba(var(--eventflow-base-rgb),0.4);
                }
                /* event grid */
                .ce-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 16px;
                }
                /* event card */
                .ce-card {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 14px; padding: 24px;
                    transition: all 0.3s; position: relative;
                    overflow: hidden; display: flex; flex-direction: column;
                }
                .ce-card::before {
                    content: '';
                    position: absolute; top: 0; left: 0; right: 0; height: 2px;
                    background: linear-gradient(90deg, var(--eventflow-base), var(--eventflow-primary));
                    opacity: 0; transition: opacity 0.3s;
                }
                .ce-card:hover { border-color: rgba(var(--eventflow-base-rgb),0.3); transform: translateY(-4px); box-shadow: 0 16px 40px rgba(0,0,0,0.3); }
                .ce-card:hover::before { opacity: 1; }
                /* card header */
                .ce-card__top {
                    display: flex; align-items: center;
                    justify-content: space-between; margin-bottom: 14px;
                }
                .ce-card__cat {
                    font-family: var(--eventflow-font);
                    font-size: 10px; font-weight: 700;
                    letter-spacing: 1.5px; text-transform: uppercase;
                    color: var(--eventflow-base);
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    border-radius: 20px; padding: 3px 10px;
                }
                .ce-card__mode {
                    display: inline-flex; align-items: center; gap: 5px;
                    font-family: var(--eventflow-font);
                    font-size: 11px; color: rgba(255,255,255,0.4);
                }
                .ce-card__mode-dot {
                    width: 6px; height: 6px; border-radius: 50%;
                }
                .ce-card__title {
                    font-family: var(--eventflow-font);
                    font-size: 16px; font-weight: 800;
                    color: #fff; margin-bottom: 10px; line-height: 1.3;
                }
                .ce-card__desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.45);
                    line-height: 1.65; margin-bottom: 16px; flex: 1;
                }
                .ce-card__meta {
                    display: flex; flex-direction: column; gap: 5px;
                    margin-bottom: 16px;
                }
                .ce-card__meta-item {
                    display: flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.45);
                }
                .ce-card__meta-item i { color: var(--eventflow-base); font-size: 11px; width: 12px; }
                .ce-card__tags {
                    display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 16px;
                }
                .ce-card__tag {
                    font-family: var(--eventflow-font);
                    font-size: 10px; font-weight: 600;
                    color: rgba(255,255,255,0.4);
                    background: rgba(255,255,255,0.04);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 4px; padding: 2px 8px;
                }
                .ce-card__footer {
                    display: flex; align-items: center;
                    justify-content: space-between; gap: 12px;
                    margin-top: auto;
                }
                .ce-card__seats {
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.35);
                }
                .ce-card__seats strong { color: var(--eventflow-base); }
                .ce-card__btn {
                    display: inline-flex; align-items: center; gap: 6px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; font-weight: 600;
                    color: var(--eventflow-base);
                    text-decoration: none; transition: gap 0.2s;
                }
                .ce-card__btn:hover { gap: 10px; }
                .ce-card__btn i { font-size: 11px; }
                /* featured specific */
                .ce-feat-left {}
                .ce-feat-title {
                    font-family: var(--eventflow-font);
                    font-size: 26px; font-weight: 900;
                    color: #fff; margin-bottom: 10px; line-height: 1.2;
                }
                .ce-feat-desc {
                    font-family: var(--eventflow-font);
                    font-size: 14px; color: rgba(255,255,255,0.5);
                    line-height: 1.7; margin-bottom: 16px; max-width: 560px;
                }
                .ce-feat-meta {
                    display: flex; flex-wrap: wrap; gap: 16px; margin-bottom: 16px;
                }
                .ce-feat-meta-item {
                    display: flex; align-items: center; gap: 7px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.55);
                }
                .ce-feat-meta-item i { color: var(--eventflow-base); }
                .ce-feat-tags { display: flex; flex-wrap: wrap; gap: 8px; }
                .ce-feat-tag {
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 600;
                    color: rgba(255,255,255,0.45);
                    background: rgba(255,255,255,0.05);
                    border: 1px solid rgba(255,255,255,0.08);
                    border-radius: 4px; padding: 3px 10px;
                }
                .ce-feat-right { text-align: center; flex-shrink: 0; }
                .ce-feat-seats-num {
                    font-family: var(--eventflow-font);
                    font-size: 40px; font-weight: 900;
                    color: var(--eventflow-base); line-height: 1;
                    margin-bottom: 4px;
                }
                .ce-feat-seats-lbl {
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 600;
                    letter-spacing: 2px; text-transform: uppercase;
                    color: rgba(255,255,255,0.3); margin-bottom: 20px;
                }
                @media (max-width: 991px) {
                    .ce-grid { grid-template-columns: repeat(2,1fr); }
                    .ce-featured { grid-template-columns: 1fr; }
                    .ce-feat-right { text-align: left; }
                    .ce-sec-title { font-size: 34px; }
                }
                @media (max-width: 576px) {
                    .ce-grid { grid-template-columns: 1fr; }
                    .ce-featured { padding: 24px 20px; }
                }
            `}</style>

            <div className="container">
                <div className="text-center mb-5 wow fadeInUp" data-wow-delay="100ms">
                    <div className="ce-sec-tag" style={{justifyContent:'center'}}>{communityData.upcomingSection.tag}</div>
                    <h2 className="ce-sec-title" style={{textAlign:'center'}}>{communityData.upcomingSection.titleStart} <span>{communityData.upcomingSection.titleAccent}</span></h2>
                    <p style={{color:'rgba(255,255,255,0.45)',fontSize:'15px',maxWidth:'500px',margin:'0 auto'}}>
                        {communityData.upcomingSection.subtitle}
                    </p>
                </div>

                {/* Filters */}
                <div className="ce-filters wow fadeInUp" data-wow-delay="150ms">
                    {CATEGORIES.map((c,i) => (
                        <button key={i} className={`ce-filter${active===c?' ce-filter--active':''}`} onClick={() => setActive(c)}>{c}</button>
                    ))}
                </div>

                {/* Featured event */}
                {(active === 'All' || active === 'Conference Archive') && (
                    <div className="ce-featured wow fadeInUp" data-wow-delay="150ms">
                        <span className="ce-featured__badge">⭐ Featured</span>
                        <div className="ce-feat-left">
                            <div className="ce-card__cat" style={{display:'inline-block',marginBottom:'12px'}}>Conference</div>
                            <div className="ce-feat-title">{events[0].title}</div>
                            <p className="ce-feat-desc">{events[0].desc}</p>
                            <div className="ce-feat-meta">
                                <span className="ce-feat-meta-item"><i className="fa fa-calendar-alt" />{events[0].date}</span>
                                <span className="ce-feat-meta-item"><i className="fa fa-clock" />{events[0].time}</span>
                                <span className="ce-feat-meta-item"><i className="fa fa-map-marker-alt" />{events[0].venue}, {events[0].location}</span>
                            </div>
                            <div className="ce-feat-tags">
                                {events[0].tags.map((t,i) => <span className="ce-feat-tag" key={i}>{t}</span>)}
                            </div>
                        </div>
                        <div className="ce-feat-right">
                            <div className="ce-feat-seats-num">{events[0].seatsLeft}</div>
                            <div className="ce-feat-seats-lbl">Seats Left</div>
                            <a href={events[0].link} className="thm-btn">
                                Register Now <span className="icon-arrow-right" />
                            </a>
                        </div>
                    </div>
                )}

                {/* Events grid */}
                <div className="ce-grid wow fadeInUp" data-wow-delay="200ms">
                    {filtered.filter(e => !e.featured).map((ev, i) => (
                        <div className="ce-card" key={ev.id}>
                            <div className="ce-card__top">
                                <span className="ce-card__cat">{ev.category}</span>
                                <span className="ce-card__mode">
                                    <span className="ce-card__mode-dot" style={{background: modeColors[ev.mode]}} />
                                    {ev.mode === 'online' ? 'Online' : 'In-Person'}
                                </span>
                            </div>
                            <div className="ce-card__title">{ev.title}</div>
                            <p className="ce-card__desc">{ev.desc}</p>
                            <div className="ce-card__meta">
                                <div className="ce-card__meta-item"><i className="fa fa-calendar-alt" />{ev.date}</div>
                                <div className="ce-card__meta-item"><i className="fa fa-clock" />{ev.time}</div>
                                <div className="ce-card__meta-item"><i className="fa fa-map-marker-alt" />{ev.venue}</div>
                            </div>
                            <div className="ce-card__tags">
                                {ev.tags.map((t,j) => <span className="ce-card__tag" key={j}>{t}</span>)}
                            </div>
                            <div className="ce-card__footer">
                                <span className="ce-card__seats"><strong>{ev.seatsLeft}</strong> / {ev.seats} seats left</span>
                                <a href={ev.link} className="ce-card__btn">
                                    Register <i className="fa fa-arrow-right" />
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

